import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { useSelector } from 'react-redux'

export function useNewSportsOffering() {
  const isKambiSportsOfferingFeatureActive = useFeature(
    FeatureFlags.KAMBI_SPORTS_OFFERING_INTEGRATION.key
  )
  const isLocallyEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  const isKambiSportsOfferingEnabled = isKambiSportsOfferingFeatureActive && isLocallyEnabled

  return isKambiSportsOfferingEnabled
}
